(() => {
  angular
    .module('gm.common.header')
    .directive('gmGlobalLivePrice', gmGlobalLivePriceDirective);

  /**
   * Marketing website.
   * Global live price menu.
   *
   * @param {Object} $filter
   * @param {Object} $document
   * @param {Object} GmyCurrencies
   */
  function gmGlobalLivePriceDirective(
    $filter,
    $rootScope,
    GmyCurrencies
  ) {
    'ngInject';

    const has = Object.prototype.hasOwnProperty;

    return {
      restrict: 'E',
      replace: true,
      scope: {},
      templateUrl: 'modules/header/directives/global-live-price/global-live-price.html',

      link(scope, element, attrs) {
        /**
         * Map list for menu
         *
         * @param  {Array} list
         * @return {Array}
         */
        function prepareCurrencyListForMenu(list) {
          return list.map(c => ({
            id: c.code,
            flag: c.flag,
            name: c.name,
            meta: c.code
          }));
        }

        scope.active = false;
        scope.showLabel = has.call(attrs, 'showLabel');
        scope.white = has.call(attrs, 'white');
        scope.dot = has.call(attrs, 'dot');
        scope.model = {
          filterInput: ''
        };

        const currencyHash = GmyCurrencies.getCurrencyHash();
        const currencyList = GmyCurrencies.getCurrencies();
        const topCountries = GmyCurrencies.getTopCountries();
        const groupedCountries = GmyCurrencies.getCountriesByGroups();

        scope.exchange = $rootScope.exchange;
        scope.topCountries = prepareCurrencyListForMenu(topCountries);
        scope.groupedCountries = Object.keys(groupedCountries)
          .reduce((result, continent) => {
            result[continent] = prepareCurrencyListForMenu(groupedCountries[continent]);
            return result;
          }, {});

        // save selected currency data
        scope.currency = GmyCurrencies.getTempLivePriceCurrency();
        $rootScope.currency = scope.currency.code;
        const deregisterCurrencyListener = scope.$on('gm:currency:changed', (_event, currency) => {
          scope.currency = currency;
        });

        scope.$watch('model.filterInput', (filterInput) => {
          const filteredList = filterInput
            ? $filter('filter')(currencyList, filterInput)
            : currencyList;

          scope.filteredCurrencyList = prepareCurrencyListForMenu(filteredList);
        });

        element.on('gm:flyout-switch', () => {
          scope.active = !scope.active;
        });

        element.on('gm:flyout-close', () => {
          scope.active = false;
        });

        scope.$watch(() => element.find('.flyout').hasClass('active'), (newVal, oldVal) => {
          if (newVal !== oldVal) {
            scope.active = newVal;
          }
        });

        scope.setActiveCode = (currencyCode) => {
          const currency = currencyHash[currencyCode];

          // set currency locally, globally
          scope.currency = currency;
          $rootScope.$broadcast('gm:currency:changed', currency);
          $rootScope.currency = currencyCode;
          GmyCurrencies.setDefaultCurrencyCode(currency.code);

          // close flyout
          $rootScope.$broadcast('gm:flyout-close');
        };

        scope.$on('$destroy', () => {
          $rootScope.$broadcast('gm:flyout-close');
          deregisterCurrencyListener();
        });
      }
    };
  }
})();
